import { makeVar } from '@apollo/client';

export const isFeedbackModalOpenVar = makeVar(false);
export const isUnavailableModalOpenVar = makeVar(false);
